/* B2B references only. This module never calls cart or checkout APIs. */
(function () {
  if (window.ancoolyB2bBound) return;
  window.ancoolyB2bBound = true;
  const pickers = new WeakMap();
  function getForm() { return document.querySelector('#inquiry form'); }
  function syncReference(root) {
    const form = getForm();
    if (!root || !form) return;
    const field = form.querySelector('[data-ac-inquiry-product]');
    const variant = root.querySelector('[data-ac-b2b-variant]');
    if (field) field.value = root.getAttribute('data-ac-b2b-product') + (variant && variant.value ? ' — ' + variant.value : '');
  }
  function showImage(root, url, thumbnail) {
    if (!url || !/^(https?:\/\/|\/\/)/i.test(url)) return;
    const gallery = root.querySelector('.ac-b2b-gallery');
    const main = gallery && gallery.querySelector('.ac-b2b-main-image img');
    if (!main) return;
    main.src = url;
    main.removeAttribute('srcset');
    gallery.querySelectorAll('[data-ac-b2b-image]').forEach(function (item) { item.removeAttribute('aria-current'); });
    if (thumbnail) thumbnail.setAttribute('aria-current', 'true');
  }
  function refreshPicker(root, updateInquiry) {
    const state = pickers.get(root);
    if (!state) return;
    const selected = [];
    state.selects.forEach(function (select, index) {
      const previous = select.value;
      const ready = selected.every(function (value) { return value !== ''; });
      const candidates = ready ? state.variants.filter(function (variant) {
        return selected.every(function (value, i) { return variant.options[i] === value; });
      }) : [];
      const values = Array.from(new Set(candidates.map(function (variant) { return variant.options[index]; })));
      select.replaceChildren(new Option(state.placeholders[index], ''));
      values.forEach(function (value) { select.add(new Option(value, value)); });
      select.disabled = !ready;
      select.value = values.includes(previous) ? previous : '';
      selected.push(select.value);
    });
    const match = selected.every(function (value) { return value !== ''; }) && state.variants.find(function (variant) {
      return selected.every(function (value, index) { return variant.options[index] === value; });
    });
    state.fallback.value = match ? match.reference : '';
    if (state.label) state.label.textContent = match ? match.title + (match.sku ? ' · SKU: ' + match.sku : '') : 'Choose each option to identify a listed reference.';
    if (updateInquiry) {
      syncReference(root);
      if (match && match.image) showImage(root, match.image);
    }
  }
  function initialize(root) {
    if (pickers.has(root)) return;
    const wrapper = root.querySelector('[data-ac-b2b-option-picker]');
    const source = root.querySelector('[data-ac-b2b-options]');
    const fallback = root.querySelector('[data-ac-b2b-variant]');
    if (!wrapper || !source || !fallback) return;
    const selects = Array.from(wrapper.querySelectorAll('[data-ac-b2b-option]')).sort(function (a, b) {
      return Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex);
    });
    let variants;
    try { variants = JSON.parse(source.textContent); } catch (_) { return; }
    const references = Array.from(fallback.options).map(function (option) { return option.value; });
    const combinations = new Set();
    if (!selects.length || !selects.every(function (select, index) { return select.dataset.optionIndex === String(index); }) || !Array.isArray(variants) || !variants.length || !variants.every(function (variant) {
      if (!variant || typeof variant.title !== 'string' || typeof variant.reference !== 'string' || !variant.reference || !references.includes(variant.reference) || !Array.isArray(variant.options) || variant.options.length !== selects.length || !variant.options.every(function (value) { return typeof value === 'string' && value !== ''; })) return false;
      const key = JSON.stringify(variant.options);
      if (combinations.has(key)) return false;
      combinations.add(key);
      return true;
    })) return;
    const current = variants.find(function (variant) { return variant.reference === fallback.value; });
    const placeholders = selects.map(function (select) {
      const empty = Array.from(select.options).find(function (option) { return option.value === ''; });
      return empty ? empty.textContent : 'Choose an option';
    });
    if (current) selects.forEach(function (select, index) {
      // Ensure an existing fallback selection survives initial enhancement.
      select.add(new Option(current.options[index], current.options[index], false, true));
    });
    pickers.set(root, { variants: variants, selects: selects, placeholders: placeholders, fallback: fallback, label: root.querySelector('[data-ac-b2b-selected-label]') });
    refreshPicker(root, false);
    const fallbackWrapper = fallback.closest('[data-ac-b2b-fallback]');
    if (fallbackWrapper) fallbackWrapper.hidden = true;
    wrapper.hidden = false;
  }
  function initializeAll() { document.querySelectorAll('[data-ac-b2b-product]').forEach(initialize); }
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-ac-b2b-option]')) refreshPicker(event.target.closest('[data-ac-b2b-product]'), true);
    else if (event.target.matches('[data-ac-b2b-variant]')) syncReference(event.target.closest('[data-ac-b2b-product]'));
  });
  document.addEventListener('click', function (event) {
    const photo = event.target.closest('[data-ac-b2b-image]');
    if (photo) {
      const root = photo.closest('[data-ac-b2b-product]');
      if (root && root.querySelector('.ac-b2b-main-image img')) {
        event.preventDefault();
        showImage(root, photo.getAttribute('data-ac-b2b-image'), photo);
      }
    }
    const inquire = event.target.closest('[data-ac-b2b-inquire], [data-ac-b2b-sample]');
    if (!inquire) return;
    const root = inquire.closest('[data-ac-b2b-product]');
    const form = getForm();
    if (!root || !form) return;
    syncReference(root);
    if (inquire.hasAttribute('data-ac-b2b-sample')) {
      const sampleField = form.querySelector('[data-ac-sample-interest]');
      if (sampleField) sampleField.value = 'Please confirm sample availability, cost and dispatch timing.';
    }
  });
  document.addEventListener('shopify:section:load', initializeAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
})();
